import { cn } from "@lib/cn";
import { useSlidesLibraryStore } from "../store";
import { selectionOrderOf } from "../utils/slide-selection";

/**
 * The slide's place in the deck being assembled (Figma 991:119405): a small
 * violet disc with its 1-based position, shown only while the slide is
 * picked. The number is the order the slides were picked in, which is the
 * order they will be in the new document.
 */
export const SelectionOrderBadge = ({
  id,
  className,
}: {
  id: string;
  className?: string;
}) => {
  const order = useSlidesLibraryStore((s) =>
    selectionOrderOf(s.multiSelectSlides, id),
  );
  if (order === null) return null;
  return (
    <span
      aria-label={`Slide ${order} of the new document`}
      className={cn(
        "tw-flex tw-size-5 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-full tw-bg-[#D5CDFF] tw-font-sans tw-text-xs tw-font-medium tw-leading-4 tw-text-primary",
        className,
      )}
    >
      {order}
    </span>
  );
};
